module.exports = __webpack_public_path__ + "img/create_new_campaign.36002ac6.png";